import "./loading-overlay.scss";

import { useEffect, useState } from "react";

export default function LoadingOverlay({ isLoading }) {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (!isLoading) {
      // Start fade out animation when loading finishes
      setTimeout(() => setFadeOut(true), 100); // small delay before fade out
    } else {
      setFadeOut(false); // reset when loading starts
    }
  }, [isLoading]);

  return isLoading || !fadeOut ? (
    <div className={`loading-overlay ${fadeOut ? "fade-out" : ""}`}>
      <img
        src={`${process.env.PUBLIC_URL}/images/icons/loading_logo.webp`}
        alt="Loading"
        className="loading-logo"
        loading="lazy"
      />
    </div>
  ) : null;
}
